import { useNavigate } from 'react-router-dom'
import { Table, Input } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import CustomSelectListInput from '../CustomSelectListInput'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import DateRangeInput from '../DateRangeInput'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'
import TextInput from '../TextInput'

export default function MedicareNewForm({ location }) {
  console.log('MedicareNewForm rendered: ', location)

  let init = {
    dueDateFrom: '',
    dueDateTo: '',
    settlementDateFrom: '',
    settlementDateTo: '',
    releaseDateFrom: '',
    releaseDateTo: '',
    amountOperator: '',
    settlementAmount: '',
    status: [],
    medicareReportingType: [],
    medicareClaimNumber: '',
    checkNumber: 'Y',
    addColumns: ''
  }

  const navigate = useNavigate()
  init = initialFormValues('MedicareNewForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    submitFormValues('MedicareNewForm', navigate, inputs, 'medicare_new.report')
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit} style={{ maxWidth: '700px', margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{ backgroundColor: 'white' }}>
            <FormHeading headingText='Medicare Report - New 2023' />
            <tbody>
              <DateRangeInput label='Payment Due Date' name='dueDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.dueDateFrom} defaultValueTo={inputs.dueDateTo} />
              <DateRangeInput label='Settlement Date' name='settlementDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.settlementDateFrom} defaultValueTo={inputs.settlementDateTo} />
              <DateRangeInput label='Release Date' name='releaseDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.releaseDateFrom} defaultValueTo={inputs.releaseDateTo} />
              <tr>
                <td><b>Settlement Amount</b></td>
                <td>
                  <Input
                    type="select"
                    name="amountOperator"
                    onChange={handleInputChange}
                    style={{ width: 'auto', display: 'inline-block', marginRight: '5px' }}
                    defaultValue={inputs.amountOperator}
                  >
                    <option value={''}></option>
                    <option value={'>'}>Greater Than</option>
                    <option value={'='}>Equal To</option>
                    <option value={'<'}>Less Than</option>
                  </Input>
                  <Input style={{ width: 'auto', display: 'inline-block' }} name="settlementAmount" onChange={handleInputChange} defaultValue={inputs.settlementAmount} />
                </td>
              </tr>
              <CustomSelectListInput label="Plaintiff Status" handleChange={handleInputChange} modelName="Asbestos" entityName="plaintiff_status" name='status' multiple={true} defaultValue={inputs.status} />
              <CustomSelectListInput label="Medicare Reporting Type" handleChange={handleInputChange} modelName="Asbestos" entityName="medicare_type" name='medicareReportingType' multiple={true} defaultValue={inputs.status} />
              <TextInput label='Medicare Claim Number' name='medicareClaimNumber' handleInputChange={handleInputChange} defaultValue={inputs.medicareClaimNumber} />
              <tr>
                <td colSpan="2">
                  <Input className="custom-checkbox" type="checkbox" defaultChecked={inputs.checkNumber} name="checkNumber" onChange={handleInputChange} /> Include only settlement detail records that have check numbers <span><br /></span>
                </td>
              </tr>
              <tr>
                <td colSpan="2">
                  <Input className="custom-checkbox" type="checkbox" defaultChecked={inputs.addColumns} name="addColumns" onChange={handleInputChange} /> Include additional columns <span><br /></span>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
        <FormSubmitButton />
      </form>
    </div>
  )
}

